"use strict";

var _wrapRegExp = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/wrapRegExp.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.functionModifiers = exports.eventModifiers = exports.modifiers = exports.isReceiveSignature = exports.isFallbackSignature = exports.execConstructorSignature = exports.isConstructorSignature = exports.execStructSignature = exports.isStructSignature = exports.execFunctionSignature = exports.isFunctionSignature = exports.execEventSignature = exports.isEventSignature = exports.execErrorSignature = exports.isErrorSignature = void 0;
const regex_js_1 = require("../../regex.js");
const errorSignatureRegex = /*#__PURE__*/_wrapRegExp(/^error ([a-zA-Z$_][a-zA-Z0-9$_]*)\((.*?)\)$/, {
  name: 1,
  parameters: 2
});
function isErrorSignature(signature) {
  return errorSignatureRegex.test(signature);
}
exports.isErrorSignature = isErrorSignature;
function execErrorSignature(signature) {
  return (0, regex_js_1.execTyped)(errorSignatureRegex, signature);
}
exports.execErrorSignature = execErrorSignature;
const eventSignatureRegex = /*#__PURE__*/_wrapRegExp(/^event ([a-zA-Z$_][a-zA-Z0-9$_]*)\((.*?)\)$/, {
  name: 1,
  parameters: 2
});
function isEventSignature(signature) {
  return eventSignatureRegex.test(signature);
}
exports.isEventSignature = isEventSignature;
function execEventSignature(signature) {
  return (0, regex_js_1.execTyped)(eventSignatureRegex, signature);
}
exports.execEventSignature = execEventSignature;
const functionSignatureRegex = /*#__PURE__*/_wrapRegExp(/^function ([a-zA-Z$_][a-zA-Z0-9$_]*)\((.*?)\)(?: (external|public{1}))?(?: (pure|view|nonpayable|payable{1}))?(?: returns\s?\((.*?)\))?$/, {
  name: 1,
  parameters: 2,
  scope: 3,
  stateMutability: 4,
  returns: 5
});
function isFunctionSignature(signature) {
  return functionSignatureRegex.test(signature);
}
exports.isFunctionSignature = isFunctionSignature;
function execFunctionSignature(signature) {
  return (0, regex_js_1.execTyped)(functionSignatureRegex, signature);
}
exports.execFunctionSignature = execFunctionSignature;
const structSignatureRegex = /*#__PURE__*/_wrapRegExp(/^struct ([a-zA-Z$_][a-zA-Z0-9$_]*) \{(.*?)\}$/, {
  name: 1,
  properties: 2
});
function isStructSignature(signature) {
  return structSignatureRegex.test(signature);
}
exports.isStructSignature = isStructSignature;
function execStructSignature(signature) {
  return (0, regex_js_1.execTyped)(structSignatureRegex, signature);
}
exports.execStructSignature = execStructSignature;
const constructorSignatureRegex = /*#__PURE__*/_wrapRegExp(/^constructor\((.*?)\)(?:\s(payable{1}))?$/, {
  parameters: 1,
  stateMutability: 2
});
function isConstructorSignature(signature) {
  return constructorSignatureRegex.test(signature);
}
exports.isConstructorSignature = isConstructorSignature;
function execConstructorSignature(signature) {
  return (0, regex_js_1.execTyped)(constructorSignatureRegex, signature);
}
exports.execConstructorSignature = execConstructorSignature;
const fallbackSignatureRegex = /^fallback\(\)$/;
function isFallbackSignature(signature) {
  return fallbackSignatureRegex.test(signature);
}
exports.isFallbackSignature = isFallbackSignature;
const receiveSignatureRegex = /^receive\(\) external payable$/;
function isReceiveSignature(signature) {
  return receiveSignatureRegex.test(signature);
}
exports.isReceiveSignature = isReceiveSignature;
exports.modifiers = new Set(['memory', 'indexed', 'storage', 'calldata']);
exports.eventModifiers = new Set(['indexed']);
exports.functionModifiers = new Set(['calldata', 'memory', 'storage']);
//# sourceMappingURL=signatures.js.map